
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCustomerSurveyDtGrid extends Serenity.EntityGrid<PsCustomerSurveyDtRow, any> {
        protected getColumnsKey() { return PsCustomerSurveyDtColumns.columnsKey; }
        protected getDialogType() { return PsCustomerSurveyDtDialog; }
        protected getIdProperty() { return PsCustomerSurveyDtRow.idProperty; }
        protected getInsertPermission() { return PsCustomerSurveyDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCustomerSurveyDtRow.localTextPrefix; }
        protected getService() { return PsCustomerSurveyDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}